import classNames from 'classnames'
import { ChangeEvent, SelectHTMLAttributes } from 'react'
import css from 'styled-jsx/css'
import * as CONST from 'ui/constants/index'
import { useSiteInfo } from 'shared'

type Option = {
  label: string
  value: string
}

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  version?: 'half' | 'full' | 'standalone' | 'rounded'
  required?: boolean
  value?: string
  options: Option[]
  onChangeHandler?: (value: string) => void
}

export const AFormSelect = ({
  name,
  required,
  value,
  version = 'full',
  options,
  onChangeHandler,
  ...rest
}: Props) => {
  const siteInfo = useSiteInfo()

  const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChangeHandler && onChangeHandler(event.target.value)
  }

  return (
    <>
      <div
        className={classNames('a-form-select border w-full flex', {
          [version]: true,
          'mx-3 mt-6': version !== 'standalone',
          'border-gray-500': !required,
          'border-pink-500':
            required && siteInfo?.layout === CONST.SITE_LAYOUT.EVO,
          'border-primary-teal':
            required && siteInfo?.layout === CONST.SITE_LAYOUT.ICL,
          'bg-gray-100 rounded-lg': siteInfo?.layout === CONST.SITE_LAYOUT.EVO,
          'bg-white': siteInfo?.layout === CONST.SITE_LAYOUT.ICL,
          'rounded-full border-gray-800': version === 'rounded',
        })}
      >
        <select
          aria-label={rest['aria-label'] ?? name}
          className="font-body font-semibold leading-4 text-gray-800 text-base w-full p-4 bg-transparent flex-grow outline-none"
          name={name}
          required={required}
          value={value}
          onChange={onChange}
          {...rest}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <style jsx>{styles}</style>
    </>
  )
}

const styles = css`
  .a-form-select.half {
    width: calc(100% - 1.5rem);
  }

  .a-form-select.full {
    width: calc(100% - 1.5rem);
  }

  @media (min-width: 640px) {
    .a-form-select.half {
      width: calc(50% - 1.5rem);
    }

    .a-form-select.full {
      width: calc(100% - 1.5rem);
    }
  }
`
